/**
 * Google Analytics event tracking.
 * Exposes window.themeAnalytics.trackEvent(name, data) pushing to the GTM
 * dataLayer, and auto-tracks tel:/mailto: link clicks with a location
 * context derived from the surrounding Shopify section.
 */
(() => {
  const trackEvent = (eventName, eventData = {}) => {
    try {
      window.dataLayer = window.dataLayer || [];

      if (!eventName) {
        console.warn('trackEvent: Event name is required');
        return;
      }

      window.dataLayer.push({
        event: eventName,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        ...eventData,
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  };

  const getLocationContext = (element) => {
    const sectionWithDataAttr = element.closest('[data-section-id]');
    if (sectionWithDataAttr) {
      const sectionId = sectionWithDataAttr.getAttribute('data-section-id');
      const match = sectionId.match(/__([^_]+)$/);
      return match ? match[1] : sectionId;
    }

    const section = element.closest('[id^="shopify-section-"]');
    if (section) {
      const cleanId = section.id.replace('shopify-section-', '').replace(/^template--\d+__/, '');
      if (!cleanId || /^[0-9a-f]+$/i.test(cleanId)) return 'section';
      return cleanId;
    }

    if (element.closest('header')) return 'header';
    if (element.closest('footer')) return 'footer';
    if (element.closest('main')) return 'main_content';
    return 'page';
  };

  const initLinkTracking = () => {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !link.href) return;

      const location = getLocationContext(link);

      if (link.href.startsWith('tel:')) {
        trackEvent('phone_click', {
          phone_number: link.href.replace('tel:', ''),
          location: location,
        });
      } else if (link.href.startsWith('mailto:')) {
        trackEvent('email_click', {
          email: link.href.replace('mailto:', '').split('?')[0],
          location: location,
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinkTracking);
  } else {
    initLinkTracking();
  }

  window.themeAnalytics = { trackEvent };
})();
